export default __webpack_public_path__ + "static/media/38.e59a3c15.jpg";